import { useState, useCallback, useRef, useEffect } from 'react';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTracker } from '../../../context/hooks';
import { Header } from '../../sharedComponents/GroupView';
import AISearchContentRecommendations from 'seo-tools-lib/components/AISearchContentRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wrapper for AI Search recommendations with dynamic badge count.
 */
export const AiSearchGroupWrapper = ({
  contentId
}) => {
  const ref = useRef(null);
  const {
    track
  } = useTracker();
  const [isLoading, setIsLoading] = useState(true);
  const [incompleteCount, setIncompleteCount] = useState(0);
  const [open, setOpen] = useState(true);
  const highlightAISearch = window.location.search.includes('highlightAISearch');
  useEffect(() => {
    if (ref.current && highlightAISearch) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [highlightAISearch]);
  const handleIncompleteCountChange = useCallback(count => {
    setIsLoading(false);
    setIncompleteCount(count);
    setOpen(count > 0);
  }, []);
  const handleOpenChange = () => {
    if (!open) {
      track('expandedRecommendationGroup', {
        group: 'AI_SEARCH_ENGINE_OPTIMIZATION'
      });
    }
    setOpen(!open);
  };
  const renderHeader = useCallback(({
    titleText
  }) => /*#__PURE__*/_jsx(Header, {
    titleText: titleText,
    incompleteCount: isLoading ? 0 : incompleteCount
  }), [incompleteCount, isLoading]);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: /*#__PURE__*/_jsx(ExpandableSection, {
      "data-test-id": "xray-panel-group-AI_SEARCH_ENGINE_OPTIMIZATION",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.aiSearchEngineOptimization"
      }),
      Title: renderHeader,
      open: open,
      onOpenChange: handleOpenChange,
      children: /*#__PURE__*/_jsx(AISearchContentRecommendations, {
        contentId: contentId,
        onIncompleteCountChange: handleIncompleteCountChange
      })
    })
  });
};